import { requestGet, requestPost } from '@/utils/request'

export function getBannerList(params){
  return requestGet('/person/banner/listAll', params);
}
